import { handleAction, handleActions } from 'redux-actions';
import * as actions from './actions';
const initialState = {};
const handleTogglePassenger = handleAction(actions.togglePassenger, (state, { payload: passengerId }) => {
    return Object.assign(Object.assign({}, state), { [passengerId]: Object.assign(Object.assign({}, state[passengerId]), { selected: !state[passengerId].selected }) });
}, initialState);
export default handleActions({
    [actions.togglePassenger.toString()]: handleTogglePassenger
}, initialState);
